import React from "react"
import Cabecalho from "../Cabecalho"
import { ListaNotificacoes } from "./components/ListaNotificacoes"

export function VerNotificacoesFornecedor() {
    return (
        <>
            <Cabecalho pagina="Notificações" />
            <ListaNotificacoes />
        </>
    )
}
